<template>
  <div class="container container-main pt-8 pb-4 hidden xl:block">
    <!-- Footer top -->
    <div class="flex items-end content-end w-full md:justify-between xl:justify-start mb-10 md:mb-8">
      <!-- Logo -->
      <router-link v-if="theme === 'default'" class="w-[93px] md:w-[142px] xl:mr-20" to="/">
        <img loading="lazy" src="/img/logo/logo-green.svg" alt="logo" />
      </router-link>

      <router-link v-else class="w-[93px] md:w-[142px] xl:mr-20" to="/">
        <img loading="lazy" src="/img/logo/logo-kids.svg" alt="logo" />
      </router-link>

      <!-- Actions -->
      <div class="hidden xl:flex items-end content-end gap-6">
        <LocalesSwitcher
          is-for-header
          class="bg-transparency rounde-[5px] py-[7px] px-2 pr-[9px] items-end content-end rounded-[5px]"
        />
        <!-- <div class="py-[9px] px-2 bg-transparency rounded-[5px]">
          <span class="text--md text-primary">$ USD</span>
        </div> -->
      </div>

      <!-- Social List -->
      <FooterSocialList class="hidden md:flex xl:ml-auto" />
    </div>

    <!-- Footer nav -->
    <FooterNav class="mb-8" />

    <!-- Social list mobile -->
    <FooterSocialList class="md:hidden flex xl:ml-auto mb-8" />

    <!-- Copyright -->
    <div class="flex flex-col xl:flex-row-reverse xl:justify-end xl:items-center">
      <FooterCopyrightList class="mb-4 xl:mb-0" />
      <p class="text--xs text-gray xl:mr-[66px]">
        {{ $t("footer.copyright.brand", { year: new Date().getFullYear() }) }}
      </p>
    </div>
  </div>
</template>

<script setup>
import LocalesSwitcher from "../LocalesSwitcher.vue"
import FooterSocialList from "./FooterSocialList.vue"
import FooterNav from "./FooterNav.vue"
import FooterCopyrightList from "./FooterCopyrightList.vue"

import { theme } from "@/services/getSiteTheme"
</script>

<style lang="scss" scoped></style>
